import Vue from 'vue'
import { library } from '@fortawesome/fontawesome-svg-core'

// import {} from "@fortawesome/pro-thin-svg-icons";
import {
    faCheckCircle,
    faCircle,
    faFilePdf,
} from '@fortawesome/pro-regular-svg-icons'
library.add(faCheckCircle, faCircle, faFilePdf)

import {
    faMinusSquare,
    faPlusSquare,
    faCheckCircle as faCheckCircleDuo,
    faCircle as faCircleDuo,
} from '@fortawesome/pro-duotone-svg-icons'
library.add(faMinusSquare, faPlusSquare, faCheckCircleDuo, faCircleDuo)

import {
    faEdit,
    faTrashAlt,
    faLongArrowLeft,
} from '@fortawesome/pro-light-svg-icons'
library.add(faEdit, faTrashAlt, faLongArrowLeft)

import {
    faInfoCircle,
    faFileAlt,
    faCheck,
} from '@fortawesome/pro-solid-svg-icons'
library.add(faInfoCircle, faFileAlt, faCheck)

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

export default Vue.component('FontAwesomeIcon', FontAwesomeIcon)
